import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useAgents } from '../contexts/AgentContext';
import AgentList from '../components/Agents/AgentList';
import AgentModal from '../components/Agents/AgentModal';
import AgentStats from '../components/Agents/AgentStats';
import ConnectionStatus from '../components/Agents/ConnectionStatus';
import SafeIcon from '../common/SafeIcon';
import { FiFilter, FiPlus, FiSettings } from 'react-icons/fi';


const Agents = () => {
  const [showAgentModal, setShowAgentModal] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [filterStatus, setFilterStatus] = useState('all');
  const [viewMode, setViewMode] = useState('grid');

  const { agents, loading } = useAgents();

  const filteredAgents = agents.filter(agent => 
    filterStatus === 'all' || agent.status === filterStatus
  );

  const handleEditAgent = (agent) => {
    setSelectedAgent(agent);
    setShowAgentModal(true);
  };

  const handleCloseModal = () => {
    setShowAgentModal(false);
    setSelectedAgent(null);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">AI Agents</h1>
          <p className="text-gray-600">
            Manage your Thoughtly AI voice agents for recruitment calling
          </p>
        </div>
        <div className="flex gap-3">
          <div className="flex items-center gap-2">
            <SafeIcon icon={FiFilter} className="text-gray-400" />
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="all">All Agents</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
          <button
            onClick={() => setShowAgentModal(true)}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <SafeIcon icon={FiPlus} className="text-sm" />
            Create Agent
          </button>
        </div>
      </div>

      {/* Connection Status */}
      <ConnectionStatus />

      {/* Agent Stats */}
      <AgentStats />

      {/* View Toggle */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-700">
            {filteredAgents.length} agent{filteredAgents.length !== 1 ? 's' : ''}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setViewMode('grid')}
            className={`p-2 rounded-lg transition-colors ${
              viewMode === 'grid' 
                ? 'bg-blue-100 text-blue-600' 
                : 'text-gray-400 hover:text-gray-600'
            }`}
          >
            <SafeIcon icon={FiSettings} />
          </button>
          <button
            onClick={() => setViewMode('list')}
            className={`p-2 rounded-lg transition-colors ${
              viewMode === 'list' 
                ? 'bg-blue-100 text-blue-600' 
                : 'text-gray-400 hover:text-gray-600'
            }`}
          >
            <SafeIcon icon={FiSettings} />
          </button>
        </div>
      </div>

      {/* Agent List */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <AgentList
          agents={filteredAgents}
          viewMode={viewMode}
          onEditAgent={handleEditAgent}
          loading={loading}
        />
      </motion.div>

      {/* Agent Modal */}
      {showAgentModal && (
        <AgentModal
          agent={selectedAgent}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default Agents;